<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">

    <v-dialog v-model="dialog_edit" max-width="290">
      <v-card>
        <v-card-title class="text-h5">Edit level: {{ dialog_edit_index }}</v-card-title>
        <v-card-text>Select used colors and type of cauldron.</v-card-text>
        <v-text-field
          v-if="model.levels[dialog_edit_index]"
          class="ma-3 mt-n2"
          outlined
          dense
          type="number"
          label="Colors"
          :rules="colorsRule"
          @input="validateDialogColorInput(dialog_edit_index)"
          v-model="model.levels[dialog_edit_index].colors"
        >
        </v-text-field>
        <v-autocomplete
            v-if="model.levels[dialog_edit_index]"
            v-model="model.levels[dialog_edit_index].cauldron"
            :items="cauldrons"
            item-text="name"
            return-object
            outlined
            dense
            class="ma-3 mt-n4"
            label="Cauldron Type"
        ></v-autocomplete>
        <v-checkbox
            v-if="model.levels[dialog_edit_index]"
            class="ma-3 mt-n6"
            v-model="model.levels[dialog_edit_index].show_extra_rewards"
            label="Show Extra Rewards"
        ></v-checkbox>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog_edit = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-card-title>
        <span class="headline">Ancient Treasure Bundle ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>

        <v-row dense class="mb-4 pt-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-text-field
            label="Name"
            v-model.trim="model.name"
            class="mr-2"
            v-ascii-only
          />
          <v-text-field
            label="Key"
            v-model.trim="model.key"
            v-ascii-only
          />
        </v-row>

        <v-row dense class="mt-3">
          <v-card width="100%" class="ma-0 pa-2" elevation="0" outlined>
            <v-card-title class="purple--text pa-0 ma-0 ml-1">Bottles currency</v-card-title>
            <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
              <r-currency-kind-dropdown :model.sync="model.merge_currency" label="Merge currency"/>
              <span class="ml-1 mr-1 mt-n6 purple--text"> / </span>
              <v-text-field
                  style="width: 80px"
                  v-model="model.merge_currency_multiply"
                  hide-details
                  type="number"
                  class="mt-1"
                  label="Multiply"
                  @input="validateMultiplyInput"
                  :rules="multiplyRule"/>
              <span class="ml-1 mr-1 mt-n6 purple--text"> = </span>
              <r-currency-kind-dropdown :model.sync="model.bottle_currency" label="Bottle currency"/>
            </v-card-actions>
          </v-card>
          <v-card width="100%" class="ma-0 pa-2" elevation="0" outlined>
            <v-card-title class="orange--text pa-0 ma-0 ml-1">Progress currency</v-card-title>
            <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
              <r-currency-kind-dropdown :model.sync="model.progress_currency" label="Pass progress currency"/>
            </v-card-actions>
          </v-card>
          <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
            <v-card-title class="green--text pa-0 ma-0 ml-1">Products</v-card-title>
            <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
              <r-product-dropdown :model.sync="model.product" :groups="groups_product" label="Premium"/>
            </v-card-actions>
          </v-card>
          <v-card width="100%" class="ma-0 pa-2" elevation="0" outlined>
            <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
              <v-card-title class="orange--text pa-0 ma-0 ml-1">Levels</v-card-title>
              <v-spacer></v-spacer>
              <v-btn icon elevation="0" color="white" dense class="green--text" @click="row_add()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card-actions>
            <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
              <v-data-table
                  :headers="headers"
                  :items="model.levels"
                  :height="model.levels.length > 7 ? (32 * 7 + 32 + 16) : undefined"
                  item-key="none"
                  disable-pagination
                  hide-default-footer dense
                  style="white-space: nowrap; width: 100%;">
                <template v-slot:item.colors="{item}">
                  {{ item.colors }}
                </template>
                <template v-slot:item.cauldron="{item}">
                  {{ item.cauldron.name }}
                </template>
                <template v-slot:item.show_extra_rewards="{item}">
                  <v-icon
                      v-if="item.show_extra_rewards == true"
                      small
                      large
                      color="green darken-2">
                    mdi-check-bold
                  </v-icon>
                </template>
                <template v-slot:item.actions="{item, index}">
                  <v-icon @click="row_edit(index)" class="mr-2" small>mdi-pencil</v-icon>
                  <v-icon @click="row_moveup(index)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
                  <v-icon @click="row_movedown(index)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
                  <v-icon @click="row_remove(index)" class="mr-2" small>mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-card-actions>
          </v-card>
          <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
            <v-card-title class="blue--text pa-0 ma-0 ml-1 mb-2">Reward Tracks</v-card-title>
            <v-expansion-panels>
              <r-reward-bunch-panel :model.sync="model.rewards" title="Default" label="Reward" :points="true"/>
              <r-reward-bunch-panel :model.sync="model.rewards_premium" title="Premium" label="Reward" :points="true"/>
              <r-reward-bunch-panel :model.sync="model.rewards_exchange" title="Exchange" label="Reward" :points="true"/>
            </v-expansion-panels>
          </v-card>

          <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
            <v-card-title class="red--text pa-0 ma-0 ml-1 mb-2">Guards</v-card-title>
            <v-expansion-panels>
              <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
              <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
            </v-expansion-panels>
          </v-card>

          <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
            <v-card-title class="red--text pa-0 ma-0 ml-1 mb-2">Reward on merge</v-card-title>
            <v-expansion-panels>
              <r-reward-panel :model.sync="model.rewardOnMerge" title="Reward on merge"/>
            </v-expansion-panels>
          </v-card>

        </v-row>

      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import RRewardBunchPanel from "@/modules/redactor/views/reward/r-reward-bunch-panel.vue";
import {SmartOfferBundleAlchemy} from "@/modules/redactor/models/smart-offer/bundle-alchemy/SmartOfferBundleAlchemy";
import {SmartOfferBundleAlchemyLevel} from "@/modules/redactor/models/smart-offer/bundle-alchemy/SmartOfferBundleAlchemyLevel";
import {SmartOfferBundleAlchemyLevelCauldronKind} from "@/modules/redactor/models/smart-offer/bundle-alchemy/SmartOfferBundleAlchemyLevelCauldronKind";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";


export default {
  name: "r-smart-offer-bundle-alchemy",
  components: {
    RRewardPanel,
    RRewardBunchPanel,
    RProductDropdown,
    RCurrencyKindDropdown,
    RGuardMoneyPanel,
    RGuardPanel
  },
  data: () => ({
    dialog_edit_index: 0,
    dialog_edit: false,
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleAlchemy(),
    rules: ViewRules.READONLY,
    headers: [
      {text: 'Colors', value: 'colors'},
      {text: 'Cauldron', value: 'cauldron'},
      {text: 'Extra rewards popup', value: 'show_extra_rewards'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    colorsRule: [v => (!isNaN(parseFloat(v)) && v >= 3 && v <= 999) || 'Number has to be between 3 and 999'],
    multiplyRule: [v => (!isNaN(parseFloat(v)) && v >= 1 && v <= 999) || 'Number has to be between 1 and 999']
  }),
  computed: {
    groups_product() {
      return [ProductGroupKind.SMART_OFFERS]
    },
    cauldrons() {
      return SmartOfferBundleAlchemyLevelCauldronKind.getValues()
    }
  },
  methods: {
    validateMultiplyInput() {
      if (this.model.merge_currency_multiply < 1) {
        this.model.merge_currency_multiply = 1;
      }
      this.model.merge_currency_multiply = parseInt(this.model.merge_currency_multiply);
    },
    validateDialogColorInput(index) {
      if (this.model.levels.length == 0) {
        return
      }
      let value = this.model.levels[index].colors;
      let number = !isNaN(value) && (function (x) {
        return (x | 0) === x;
      })(parseFloat(value))
      if (!number || value < 0) {
        this.model.levels[index].colors = 0
      }
      this.model.levels[index].colors = parseInt(this.model.levels[index].colors)
    },
    show(rules, model) {

      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model;

      if (!this.model) {
        this.model = new SmartOfferBundleAlchemy()
        this.model.levels = [new SmartOfferBundleAlchemyLevel()];
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    },
    row_edit(index) {
      this.dialog_edit_index = index
      this.validateDialogColorInput(index)
      this.dialog_edit = true
    },
    row_moveup(index) {
      Array.prototype.swapItems = function (a, b) {
        this[a] = this.splice(b, 1, this[a])[0];
        return this;
      }
      this.model.levels.swapItems(index, index - 1)
      console.log(this.model.levels)
    },
    row_movedown(index) {
      Array.prototype.swapItems = function (a, b) {
        this[a] = this.splice(b, 1, this[a])[0];
        return this;
      }

      if (index == (this.model.levels.length - 1)) {
        this.model.levels.swapItems(0, this.model.levels.length - 1)
      } else {
        this.model.levels.swapItems(index, index + 1)
      }

      console.log(this.model.levels)
    },
    row_remove(index) {
      if (this.model.levels.length == 1) {
        return;
      }
      this.model.levels.splice(index, 1);
      console.log(this.model.levels)
    },
    row_add() {
      this.model.levels.push(new SmartOfferBundleAlchemyLevel())
    }
  }
}
</script>
